<template>
  <div>
    <ul class="nav nav-underline mb-4 border-bottom">
      <li v-for="tab in tabs" :key="tab.id" class="nav-item">
        <button
          class="nav-link"
          :class="{
            active: activeTab === tab.id,
          }"
          @click="$emit('change:tab', tab.id)"
        >
          <font-awesome-icon v-if="tab.icon" :icon="tab.icon" class="me-2" />
          {{ tab.name }}
        </button>
      </li>
    </ul>
    <div class="d-flex flex-column">
      <template v-for="tab in tabs" :key="tab.id">
        <div v-if="activeTab === tab.id">
          <slot :name="`tab-${tab.id}`"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Tab } from "@/composables/useTabs";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

defineEmits<{
  "change:tab": [tabId: string];
}>();

defineProps<{
  tabs: Tab[];
  activeTab: string;
}>();
</script>

<style scoped lang="scss">
.nav-link {
  border-bottom: 2px solid transparent;
  transition: box-shadow 0.3s ease;

  &:hover,
  &.active {
    border-bottom-color: transparent;
    box-shadow: 0 2px 0 0 var(--phoenix-primary);
  }
}

.border-bottom {
  border-bottom: 2px solid
    rgba(var(--phoenix-border-color-rgb, 222, 226, 230), 0.3) !important;
}
</style>
